import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { Image } from "hesus-ui-kit";
import { handleApiError } from "@utils/errorHandler";
import { ButtonContainer } from "@modules/ClientUsers/ClientUsersList/ClientUsersList.styled";
import deleteIcon from "@icons/ic-delete-red.svg";
import activateIcon from "@icons/ic-activate.svg";
import viewIcon from "@icons/ic-view.svg";
import resetIcon from "@icons/ic-reset-password.svg";
import "@modules/ClientUsers/ClientUsersList/ClientUsersList.scss";
import ClientUserView from "@modules/ClientUsers/ClientUserView/ClientUserView";
import AddEditContact from "@modules/Contact/AddEditContact/AddEditContact";

const STATUS_ACTIVE = 1;
const STATUS_INACTIVE = 2;
const STATUS_PENDING = 3;

const Action = (props) => {
  const { t, data, updateRefeshStatus } = props;

  const [isUpdating, setIsUpdating] = useState(false);
  const [isViewPopUp, setIsViewPopUp] = useState(false);
  const [isPasswordUpdating, setIsPasswordUpdating] = useState(false);
  const [isEditContactPopupVisible, setIsEditContactPopupVisible] =
      useState(false);
  const [contactData, setContactData] = useState([]);

  const isActive = data.status === STATUS_ACTIVE || data.status === STATUS_PENDING;

  const handleStatusToggle = (userId, userStatus) => {
    if (isUpdating) return;
    setIsUpdating(true);
    const finalStatus =
      userStatus === STATUS_ACTIVE || userStatus === STATUS_PENDING;
    const newStatus = finalStatus ? STATUS_INACTIVE : STATUS_ACTIVE;
    axios
      .put(`/general/users/${userId}/updateStatus`, JSON.stringify(newStatus), {
        headers: { "Content-Type": "application/json" },
      })
      .then(() => {
        updateRefeshStatus(true);
      })
      .catch((error) => {
        updateRefeshStatus(true);
        handleApiError(error);
      })
      .finally(() => {
        setIsUpdating(false);
      });
  };

   const handleResetPassword = (userId) => {
    setIsPasswordUpdating(true);
    axios
      .post(`/general/users/${userId}/resetPassword`)
      .then(() => {
        if (!isViewPopUp) updateRefeshStatus(true);
      })
      .catch((error) => {
        updateRefeshStatus(true);
        handleApiError(error);
      })
      .finally(() => {
        setIsUpdating(false);
         if (isViewPopUp) setIsPasswordUpdating(false);
      });
  };

  const handleView = () => {
    setIsViewPopUp(true);
  };
  const closeUserViewPopup = () => {
    setIsViewPopUp(false);
  };

  const closeContactEditPopup = () => {
    setIsEditContactPopupVisible(false);
  };

  const showConntactPopUp = (id) => {
    axios
      .get(`/contacts/${id}`)
      .then((response) => {
        setContactData(response.data[0]);
        setIsViewPopUp(false);
        setIsEditContactPopupVisible(true);
      })
      .catch((error) => {});
  };

  const refreshUserList = () => {
     updateRefeshStatus(true);
     setIsEditContactPopupVisible(false);
  }

  return (
    <>
      <ButtonContainer>
        <div>
          {isActive && (
            <>
              <Image
                src={viewIcon}
                alt={t("GENERIC_ACTION_TOOLTIP_VIEW")}
                title={t("GENERIC_ACTION_TOOLTIP_VIEW")}
                className="client-users-list__image-action-icon"
                onClick={isUpdating ? undefined : handleView}
              />
            </>
          )}
          <Image
            src={resetIcon}
            alt={t("GENERIC_ACTION_TOOLTIP_RESET")}
            title={t("ACTION_TOOLTIP_RESET_PASSWORD")}
            className="client-users-list__image-action-icon"
            onClick={
              isUpdating ? undefined : () => handleResetPassword(data.id)
            }
          />
          {isActive ? (
            <Image
              src={deleteIcon}
              onClick={() => handleStatusToggle(data.id, data.status)}
              alt={t("GENERIC_ACTION_TOOLTIP_DISABLE")}
              title={t("GENERIC_ACTION_TOOLTIP_DISABLE")}
              className={`client-users-list__image-action-icon${
                isUpdating
                  ? " client-users-list__image-action-icon--disabled"
                  : ""
              }`}
            />
          ) : (
            <Image
              src={activateIcon}
              onClick={() => handleStatusToggle(data.id, data.status)}
              alt={t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
              title={t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
              className={`client-users-list__image-action-icon${
                isUpdating
                  ? " client-users-list__image-action-icon--disabled"
                  : ""
              }`}
            />
          )}
        </div>
      </ButtonContainer>
      {isViewPopUp && (
        <ClientUserView
          id={data.id}
          onClose={closeUserViewPopup}
          updateRefeshStatus={updateRefeshStatus}
          showConntactPopUp={showConntactPopUp}
          handleResetPassword={handleResetPassword}
          isPasswordUpdating={isPasswordUpdating}
          handleStatusToggle={handleStatusToggle}
          isUpdating={isUpdating}
        />
      )}
      {isEditContactPopupVisible && (
        <AddEditContact
          id={contactData?.contactId}
          title={t("CONTACT") + " #" + contactData?.id}
          onClose={closeContactEditPopup}
          isEditMode
          contactData={contactData}
          updateRefeshStatus={refreshUserList}
        />
      )}
    </>
  );
};

Action.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  updateRefeshStatus: PropTypes.func.isRequired,
};

export default withTranslation()(Action);
